import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f2c9190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { class: "name" }

import { User } from '../../models/User';
import { Class } from '../../models/Class';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileDisplayComponent',
  props: {
    user: null,
    classes: null,
    selectedClass: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(__props.user.firstName[0] + __props.user.lastName[0]), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.user.firstName) + " " + _toDisplayString(__props.user.lastName), 1)
  ]))
}
}

})